export enum ReservationDevices {
  Auditory = "Auditory",
  Specialist = "Specialist",
  wheelchair = "wheelchair",
  map = "map",
}
